import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from './rootReducer'

export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(
      thunkMiddleware,
      // Only run the logger in staging and dev envs
      createLogger({ predicate: (getState,action) => ['development','staging'].includes(process.env.REACT_APP_ENV) || !process.env.REACT_APP_ENV})
    )
  )
}
